import React from 'react'

const Greeting = ({ subject }) => {
  try {
    return <div>{`Hi ${subject.name}, hope you are well.`}</div>
  } catch (error) {
    return (
      <div
        style={{
          background: '#ccc',
          padding: '.5em 1em',
          display: 'inline-block',
          color: '#fff',
          fontWeight: 'bold',
        }}
      >{`Error on Greeting component: ${error}`}</div>
    )
  }
}

export default Greeting
